class PolygonMaskReveal extends Phaser.Group {
  constructor({ game }) {
    super(game);
    this.background = this.game.make.image(0, 0, 'bg_generic');
    this.add(this.background);

    this.render = this.render.bind(this);

    this.w = this.game.defaultWidth * 0.5;
    this.h = this.game.defaultHeight * 0.5;
    this.max = this.w + 100;
    this.outer = this.generateOuter();

    this.maskp = this.game.add.graphics();
    this.addChild(this.maskp);
    this.background.mask = this.maskp;
    this.render(this.max);

    this.onInComplete = new Phaser.Signal();
    this.onOutComplete = new Phaser.Signal();
    this.game.input.enabled = false;
  }

  generateOuter() {
    const x1 = 0;
    const y1 = 0;
    const x2 = this.game.defaultWidth;
    const y2 = this.game.defaultHeight;
    return [x1, y1, x2, y1, x2, y2, x1, y2, x1, y1]; // outer coords of rect mask
  }

  generatePolygon(size) {
    /**
     * https://stackoverflow.com/questions/4839993/how-to-draw-polygons-on-an-html5-canvas?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
     * https://dustinpfister.github.io/2017/10/22/phaser-graphics-polygon/
     */
    const p = []; // points array to be returned
    let i;
    for (i = 1; i <= PolygonMaskReveal.NUMBER_SIDES; i++) {
      p.push(this.w + size * Math.cos((i * 2 * Math.PI) / PolygonMaskReveal.NUMBER_SIDES));
      p.push(this.h + size * Math.sin((i * 2 * Math.PI) / PolygonMaskReveal.NUMBER_SIDES));
    }
    p.push(p[0]); // add first point to end to close polygon
    p.push(p[1]);
    return p;
  }

  render(step) {
    const inner = this.generatePolygon(step);
    const ps = [...this.outer, ...inner];
    const poly = new Phaser.Polygon(ps);
    this.maskp.clear();
    this.maskp.beginFill(0x000000, 1);
    this.maskp.drawPolygon(poly.points);
    this.maskp.endFill();
  }

  init() {}

  startIn() {
    let track = { step: this.max };
    let tween = this.game.add.tween(track).to({ step: 0 }, PolygonMaskReveal.DURATION, Phaser.Easing.Circular.Out);
    tween.onUpdateCallback(() => {
      this.render(track.step);
    });
    tween.start();
    tween.onComplete.addOnce(this.startInComplete, this);
  }

  startInComplete() {
    this.onInComplete.dispatch(this);
  }

  startOut() {
    let track = { step: 0 };
    let tween = this.game.add.tween(track).to({ step: this.max }, PolygonMaskReveal.DURATION, Phaser.Easing.Circular.In);
    tween.onUpdateCallback(() => {
      this.render(track.step);
    });
    tween.start();
    tween.onComplete.addOnce(this.startOutComplete, this);
  }

  startOutComplete() {
    this.game.input.enabled = true;
    this.onOutComplete.dispatch(this);
  }

  destroy(destroyChildren = true, soft) {
    this.game.tweens.removeFrom(this, true);
    this.game.tweens.removeFrom(this);

    this.onInComplete.forget();
    this.onInComplete.dispose();
    this.onInComplete.removeAll();

    this.onOutComplete.forget();
    this.onOutComplete.dispose();
    this.onOutComplete.removeAll();

    this.background = null;
    this.maskp = null;
    super.destroy(destroyChildren);
  }
}
PolygonMaskReveal.DURATION = 1000;
PolygonMaskReveal.NUMBER_SIDES = 16;
export default PolygonMaskReveal;
